import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { FormsModule } from '@angular/forms';
import { ToastrManager, ToastrModule } from 'ng6-toastr-notifications';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from './Service/Common.service';
import { LoaderService } from './Service/loader.service';
import { OutputService } from './Service/output.service';
import { NgxPermissionsModule } from 'ngx-permissions';
import { HttpclientInterceptor } from './Interceptor/httpclient-interceptor';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { EncrDecrService } from './Service/encr-decr.service';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LanguageTranslationModule,
        AppRoutingModule,
        FormsModule,
        GooglePlaceModule,
        ToastrModule.forRoot(),
        ModalModule.forRoot(),
        NgxPermissionsModule.forRoot(),
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'danger' // set defaults here
        })
    ],
    declarations: [AppComponent],
    providers: [
        AuthGuard,
        CommonService,
        CookieService,
        LoaderService,
        ToastrManager,
        OutputService,
        EncrDecrService,
        BsModalService,
        DatePipe,
        { provide: HTTP_INTERCEPTORS, useClass: HttpclientInterceptor, multi: true }],
    bootstrap: [AppComponent]
})
export class AppModule { }
